import { createSessionOperationStore } from "./session-operations";

export const {
  restore: restoreSourcingSessionOperations,
  persist: persistSourcingSessionOperation,
  remove: removeSourcingSessionOperation,
  clear: clearSourcingSessionOperations,
} = createSessionOperationStore({
  key: "wio-veyra.sourcing-operations.v1",
  operation:
    /^sourcing\.(create|edit|policy|allocate|release|discard|publish|amend|cancel-amendment|document\.(prepare|freeze|attach|detach))$/,
});
